import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * Created by AAravindan on 5/5/16.
 */
import { Indicator, IndicatorInput } from "../indicator/indicator";
import { AverageGain } from "../Utils/AverageGain";
import { AverageLoss } from "../Utils/AverageLoss";
export var RSIInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(RSIInput, _IndicatorInput);

  function RSIInput() {
    _classCallCheck(this, RSIInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(RSIInput).apply(this, arguments));
  }

  return RSIInput;
}(IndicatorInput);
export var RSI =
/*#__PURE__*/
function (_Indicator) {
  _inherits(RSI, _Indicator);

  function RSI(input) {
    var _this;

    _classCallCheck(this, RSI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RSI).call(this, input));
    var period = input.period;
    var values = input.values;
    var GainProvider = new AverageGain({
      period: period,
      values: []
    });
    var LossProvider = new AverageLoss({
      period: period,
      values: []
    });
    var count = 1;
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(period) {
      var current, lastAvgGain, lastAvgLoss, RS, currentRSI;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return;

            case 2:
              current = _context.sent;

            case 3:
              if (!true) {
                _context.next = 13;
                break;
              }

              lastAvgGain = GainProvider.nextValue(current);
              lastAvgLoss = LossProvider.nextValue(current);

              if (lastAvgGain !== undefined && lastAvgLoss !== undefined) {
                if (lastAvgLoss === 0) {
                  currentRSI = 100;
                } else if (lastAvgGain === 0) {
                  currentRSI = 0;
                } else {
                  RS = lastAvgGain / lastAvgLoss;
                  RS = isNaN(RS) ? 0 : RS;
                  currentRSI = parseFloat((100 - 100 / (1 + RS)).toFixed(2));
                }
              }

              count++;
              _context.next = 10;
              return currentRSI;

            case 10:
              current = _context.sent;
              _context.next = 3;
              break;

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })(period);

    _this.generator.next();

    _this.result = [];
    values.forEach(function (tick) {
      var result = _this.generator.next(tick);

      if (result.value !== undefined) {
        _this.result.push(result.value);
      }
    });
    return _this;
  }

  _createClass(RSI, [{
    key: "nextValue",
    value: function nextValue(price) {
      return this.generator.next(price).value;
    }
  }]);

  return RSI;
}(Indicator);
RSI.calculate = rsi;
export function rsi(input) {
  Indicator.reverseInputs(input);
  var result = new RSI(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}